import axios from "axios";
import { create } from "zustand";

/**
 * Dynamic Shape-routed PayPal availability. Populated by a single resolve
 * call on checkout load (see Form.jsx). Any failure (network, Shape down,
 * site not opted in) is a safe no-op: available stays false and the
 * checkout keeps its existing/local PayPal behaviour untouched.
 */
export const useShapePaypalData = create((set) => ({
  resolved: false,
  available: false,
  account: null,
  rule_id: null,

  resolve: async ({ campaignId, countryCode, affiliateTag, urlParameter } = {}) => {
    try {
      const res = await axios.get("/wp-json/checkout/v1/shape/resolve-paypal", {
        params: {
          campaign_id: campaignId || undefined,
          country: countryCode || undefined,
          affiliate_tag: affiliateTag || undefined,
          url_parameter: urlParameter || undefined,
        },
      });

      set({
        resolved: true,
        available: !!res?.data?.available,
        account: res?.data?.account ?? null,
        rule_id: res?.data?.rule_id ?? null,
      });
    } catch (err) {
      set({ resolved: true, available: false, account: null });
    }
  },
}));
